// extracted by mini-css-extract-plugin
export default {"propertyDetailsForm":"propertyDetails_propertyDetailsForm__EAqNI","propertyDetailsBox":"propertyDetails_propertyDetailsBox__YLfwb"};